import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { Card, Container, Grid, Typography } from '@mui/material';
import ReactApexChart from "react-apexcharts";
import { inspectionOrderGraphApi, issueGraphApi } from './qualityApi';
import React, { useEffect, useState } from 'react';

function QualityDashboard(props) {
  const [statusnameInspectionApi, setStatusnameInspectionApi] = useState([]);
  const [statuscountInspectionApi, setStatusCountInspectionApi] = useState([]);
  const [statusnameIssueApi, setStatusnameIssueApi] = useState([]);
  const [statuscountIssueApi, setStatusCountIssueApi] = useState([]);
  const graphTitleList = ['Inspection Work Order', 'Issue & ATC']
  const [graphTitle, setGraphTitle] = useState(graphTitleList[0]);
  const [graphIssueTitle, setIssueGraphTitle] = useState(graphTitleList[1]);
  useEffect(() => {
    inspectionOrderGraphApi(setStatusnameInspectionApi, setStatusCountInspectionApi)
    issueGraphApi(setStatusnameIssueApi, setStatusCountIssueApi)
  }, []);
  const inspectionOrderGraph = {
    options: {
      title: {
        text: graphTitle,
        align: 'center'
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        onItemClick: {
          toggleDataSeries: true
        },
      },
      labels: statusnameInspectionApi,
      chart: {
        type: 'bar',
      },
      xaxis: {
        type: 'Status Name',
        // title: {
        //   text: 'Status Name',
        // },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
      },
      plotOptions: {
        // Bar
        bar: {
          distributed: true,
          horizontal: false,
          // borderRadius: 4,
          dataLabels: {
            position: 'top',
           
          }
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: "#000000",
          // opacity: 0
        }
      },

    },
    series: [{ name: "Status Count", data: statuscountInspectionApi }]
  };
  const handleViolatedByChange = (event) => {
    setGraphTitle(event.target.value);
  };
  const issueAtcGraph = {
    options: {
      title: {
        text: graphIssueTitle,
        align: 'center'
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        onItemClick: {
          toggleDataSeries: true
        },
      },
      labels: statusnameIssueApi,
      chart: {
        type: 'bar',
      },
      xaxis: {
        type: 'Status Name',
      },
      yaxis: {
        title: {
          text: 'Count',
        },
      },
      plotOptions: {
        // Bar
        bar: {
          distributed: true,
          horizontal: false,
          dataLabels: {
            position: 'top',          
          }
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: "#000000",
          // opacity: 0
        }
      },
    },
    series: [{ name: "Status Count", data: statuscountIssueApi }]

  };

  const handleReqByPeriodChange = (event) => {
    setIssueGraphTitle(event.target.value);
  };
  return (
    <>
      <Helmet>
        <title> Home | ABEPL </title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 2 }}>
          Dashboard
        </Typography>
        <Grid container spacing={3}>

          <Grid item xs={12} md={6} lg={6}>
            <Card>
              <ReactApexChart
                options={inspectionOrderGraph.options}
                series={inspectionOrderGraph.series}
                type="bar"
                height={350}
                width="100%"
              />
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Card>
              <ReactApexChart
                options={issueAtcGraph.options}
                series={issueAtcGraph.series}
                type="bar"
                height={350}
                width="100%"
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
QualityDashboard.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};
export default QualityDashboard